const SELECTORS = {
	mapContainer: '#map-container',
	listContainer: '.clinic-search__list',
	triggersContainer: '.clinic-search__view-toggle',
	showMapTrigger: '[data-trigger="show-map"]',
	showListTrigger: '[data-trigger="show-list"]',
	// For Mobile
	navigation: '#nav',
	// filters
	mobileFilters: '.clinic-search__filters-body',
	// sort
	mobileSort: '.clinic-search__sort-body',
	// form
	formFilters: '[data-type="form-filters"]',
	formSort: '[data-type="form-sort"]',
	formRadioList: '[data-type="search-filter-radio-mobile"]',
	sortFormRadioList: '[data-type="search-sort-radio-mobile"]',
	formCheckboxList: '[data-type="search-filter-checkbox-mobile"]',
	// options
	hideFiltersContainer: '[data-type="hide-filters-container"]',
	hideSortContainer: '[data-type="hide-sort-container"]',
	hideFilters: '[data-type="hide-filters"]',
	showFilters: '[data-type="show-filters"]',
	clearFilters: '[data-type="clear-filters"]',
	saveFilters: '[data-type="save-filters"]',
	// Sort
	hideSort: '[data-type="hide-sort"]',
	showSort: '[data-type="show-sort"]',
	clearSort: '[data-type="clear-sort"]',
	saveSort: '[data-type="save-sort"]',
	// info
	infoFilters: '.clinic-search__filters-info-list',
	labelFilters: '.clinic-search__filters-label',
	labelSort: '.clinic-search__sort-label',
	// breadcrumb
	breadcrumb: '.breadcrumb',
	// search toggle
	searchBtnTrigger: '[data-search-toggle="show-search"]',
	// search form
	searchForm: '.bookdialysis-search-results__header--desktop',
};

const ELEMENTS = {
	mapContainerEle: document.querySelector(SELECTORS.mapContainer),
	listContainerEle: document.querySelector(SELECTORS.listContainer),
	triggersContainer: document.querySelector(SELECTORS.triggersContainer),
	showMapTrigger: document.querySelector(SELECTORS.showMapTrigger),
	showListTrigger: document.querySelector(SELECTORS.showListTrigger),
	// For Mobile
	navigation: document.querySelector(SELECTORS.navigation),
	// filters
	mobileFilters: document.querySelector(SELECTORS.mobileFilters),
	// sort
	mobileSort: document.querySelector(SELECTORS.mobileSort),
	// form
	formFilters: document.querySelector(SELECTORS.formFilters),
	formSort: document.querySelector(SELECTORS.formSort),
	formRadioList: [...document.querySelectorAll(SELECTORS.formRadioList)],
	sortFormRadioList: [...document.querySelectorAll(SELECTORS.sortFormRadioList)],
	formCheckboxList: [...document.querySelectorAll(SELECTORS.formCheckboxList)],
	// options
	hideFiltersContainer: document.querySelector(SELECTORS.hideFiltersContainer),
	hideSortContainer: document.querySelector(SELECTORS.hideSortContainer),
	hideFilters: document.querySelectorAll(SELECTORS.hideFilters),
	showFilters: document.querySelector(SELECTORS.showFilters),
	clearFilters: document.querySelector(SELECTORS.clearFilters),
	saveFilters: document.querySelector(SELECTORS.saveFilters),
	// sort
	hideSort: document.querySelector(SELECTORS.hideSort),
	showSort: document.querySelector(SELECTORS.showSort),
	clearSort: document.querySelector(SELECTORS.clearSort),
	saveSort: document.querySelector(SELECTORS.saveSort),
	// info
	infoFilters: document.querySelector(SELECTORS.infoFilters),
	labelFilters: document.querySelector(SELECTORS.labelFilters),
	labelSort: document.querySelector(SELECTORS.labelSort),
	// breadcrumb
	breadcrumb: document.querySelector(SELECTORS.breadcrumb),
	// search toggle
	searchBtnTrigger: document.querySelector(SELECTORS.searchBtnTrigger),
	// search form
	searchForm: document.querySelector(SELECTORS.searchForm),
};

const CLASSES = {
	active: 'active',
	displayNone: 'display--none',
	showMap: 'clinic-search__map-container--show',
	hideList: 'hide-list',
	borderNone: 'border--none',
};

export default { CLASSES, SELECTORS, ELEMENTS };
